exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-promoted__link{display:block;width:100%}.ebx-promoted__img{width:100%}.ebx-promoted .ebx-broken-image-icon{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;padding:calc(40% - 50px);width:100%}", ""]);
